import React from 'react'
import { useTheme } from '../ThemeContext'

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmStyle = 'danger' // 'danger' or 'primary'
}) {
  const { darkMode } = useTheme()

  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose()
  }

  const confirmBg = confirmStyle === 'danger'
    ? { bg: '#dc2626', hover: '#b91c1c' }
    : { bg: '#2563eb', hover: '#1d4ed8' }

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed', inset: 0, zIndex: 1100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(0,0,0,0.5)'
      }}
    >
      <div style={{
        backgroundColor: darkMode ? '#1e2d3d' : '#ffffff',
        borderRadius: '12px',
        boxShadow: darkMode
          ? '0 20px 60px rgba(0,0,0,0.6)'
          : '0 20px 60px rgba(0,0,0,0.2)',
        maxWidth: '440px',
        width: '100%',
        padding: '1.5rem',
        border: darkMode ? '1px solid rgba(90,127,173,0.2)' : '1px solid rgba(0,0,0,0.08)'
      }}>
        {title && (
          <h3 style={{ margin: '0 0 0.75rem', fontSize: '1.1rem', fontWeight: '700', color: darkMode ? '#c8daf5' : '#1a2a3e' }}>
            {title}
          </h3>
        )}
        <div style={{ marginBottom: '1.5rem', fontSize: '0.9rem', color: darkMode ? '#7aa0c8' : '#4a6080', whiteSpace: 'pre-line', lineHeight: 1.5 }}>
          {message}
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              border: `1px solid ${darkMode ? 'rgba(90,127,173,0.3)' : '#d1d5db'}`,
              borderRadius: '8px',
              backgroundColor: 'transparent',
              color: darkMode ? '#7aa0c8' : '#374151',
              fontWeight: '600',
              fontSize: '0.875rem',
              cursor: 'pointer'
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.5rem 1rem',
              border: 'none',
              borderRadius: '8px',
              backgroundColor: confirmBg.bg,
              color: 'white',
              fontWeight: '600',
              fontSize: '0.875rem',
              cursor: 'pointer'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
